import GamePage from "../../components/GameSelect/GamePage";

const RNG = () => {
  return <GamePage platformType={`TABLE`} specialColor={`#FDC003`} />;
};

export default RNG;
